import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { Button } from 'components';
import { RootState } from 'reducers';
import { Logo } from 'assets/img';
import { UserBusiness1Icon, UserBusiness2Icon, UserNatural1Icon, UserNatural2Icon } from 'assets/icons';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Register extends React.Component<Props> {

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Regístrate',
				onBack: null
			}
		});
	}

	render() {
		return (
			<div id="register">
				<div className="wrapper">
					<div className="container-logo">
						<img src={ Logo } alt="Logo" />
					</div>

					<p className="welcome">Elige el perfil que más se adapte a tus necesidades</p>

					<div className="card-wrapper">
						<Link to="/register/natural">
							<div className="card-btn">
								<img className="sup-icon" src={ UserNatural1Icon } alt="Icon" />
								<img className="main-icon" src={ UserNatural2Icon } alt="Icon" />
								<div className="details">
									<p className="title">Persona natural</p>
									<p className="content">Sólo será necesario tu cédula de identidad. El RIF es opcional.</p>
								</div>
							</div>
						</Link>

						<p className="tip">Si aún no tienes una empresa registrada esta será tu mejor opción</p>

						<Link to="/register/business">
							<div className="card-btn">
								<img className="sup-icon" src={ UserBusiness1Icon } alt="Icon" />
								<img className="main-icon" src={ UserBusiness2Icon } alt="Icon" />
								<div className="details">
									<p className="title">Empresa</p>
									<p className="content">Si dispones de una marca registrada, será necesario el registro mercantil y el RIF de la empresa.</p>
								</div>
							</div>
						</Link>

						<p className="tip">Si dispones de una amplia flota de vehículos esta será la mejor opción</p>

						<Button color="primary flat rounded-full" onClick={() => this.props.history.goBack()}>
							Volver
						</Button>
					</div>
				</div>
			</div>
		)
	}
}

export default connect()(Register);